import React from 'react';
import { Link } from 'react-router-dom';
import { useEvents } from '../context/EventsContext';
import { getMinecraftItemIcon, formatEventDate, getRelativeTime, renderMinecraftTextHTML } from '../utils/minecraftIcons';
import './EventPreview.css';

// Helper to clean description (replace /n with space)
function cleanDescription(text) {
  if (!text) return null;
  return text
    .split('/n').join(' ')
    .split('\\n').join(' ')
    .split('\n').join(' ');
}

export default function EventPreview() {
  const { events, loading, error } = useEvents();

  if (loading) {
    return (
      <section className="event-preview section">
        <div className="container">
          <h2 className="section-title animate-slide-up">Upcoming Events</h2>
          <div className="event-preview-loading">
            <div className="loading-spinner"></div>
            <p>Loading events...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error || events.length === 0) {
    return (
      <section className="event-preview section">
        <div className="container">
          <h2 className="section-title animate-slide-up">Upcoming Events</h2>
          <div className="event-preview-empty">
            <div className="empty-icon">
              <i className="mdi mdi-calendar-blank"></i>
            </div>
            <h3>No Upcoming Events</h3>
            <p>Check back soon or join our Discord to be notified of new events!</p>
            <a
              href="https://discord.thetopia.net"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-large"
            >
              <i className="mdi mdi-discord"></i> Join Discord
            </a>
          </div>
        </div>
      </section>
    );
  }

  // Show only first 3 events on home page
  const previewEvents = events.slice(0, 3);

  return (
    <section className="event-preview section">
      <div className="container">
        <h2 className="section-title animate-slide-up">Upcoming Events</h2>
        <div className="event-preview-list">
          {previewEvents.map((event, index) => (
            <div key={event.id || index} className="event-item">
              <div className="event-item-icon">
                <img
                  src={getMinecraftItemIcon(event.item)}
                  alt=""
                  onError={(e) => {
                    e.target.src = '/logo.png';
                  }}
                />
              </div>
              <div className="event-item-content mc-tooltip-large">
                <div className="event-item-header">
                  <span className="event-server-tag">{event.server || 'TheTopia'}</span>
                  <span className="event-countdown mc-text-green">
                    {getRelativeTime(event.timestamp)}
                  </span>
                </div>
                <h3
                  className="event-item-title mc-text"
                  dangerouslySetInnerHTML={{ __html: renderMinecraftTextHTML(event.name) }}
                />
                <p className="event-item-description mc-lore-gray">{cleanDescription(event.description)}</p>
                <div className="event-item-datetime mc-text-white">
                  <i className="mdi mdi-calendar"></i>
                  <span>{formatEventDate(event.timestamp)}</span>
                </div>
                {event.voicechat && (
                  <div className="event-voicechat-badge">
                    <i className="mdi mdi-microphone"></i>
                    <span>Voice Chat Required</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {events.length > 3 && (
          <div className="event-preview-cta">
            <Link to="/events" className="btn btn-outline">
              View All Events ({events.length})
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
